import "/__w/1/s/BotFramework-WebChat/packages/component/src/ActivityFeedback/private/FeedbackForm.module_built.css";
const classes = {"feedback-form__submission-button-bar":"w_eFzsG_feedback-form__submission-button-bar","feedback-form__text-box":"w_eFzsG_feedback-form__text-box","feedback-form__cancel-button":"w_eFzsG_feedback-form__cancel-button","feedback-form__text-area":"w_eFzsG_feedback-form__text-area","feedback-form":"w_eFzsG_feedback-form","feedback-form__submit-button":"w_eFzsG_feedback-form__submit-button","feedback-form__form-header":"w_eFzsG_feedback-form__form-header","feedback-form__form-footer":"w_eFzsG_feedback-form__form-footer","feedback-form__vote-button-bar":"w_eFzsG_feedback-form__vote-button-bar","feedback-form__form":"w_eFzsG_feedback-form__form"}
export default classes

const _feedback_form__submission_button_bar0 = classes["feedback-form__submission-button-bar"]
export { _feedback_form__submission_button_bar0 as "feedback-form__submission-button-bar" }

const _feedback_form__text_box0 = classes["feedback-form__text-box"]
export { _feedback_form__text_box0 as "feedback-form__text-box" }

const _feedback_form__cancel_button0 = classes["feedback-form__cancel-button"]
export { _feedback_form__cancel_button0 as "feedback-form__cancel-button" }

const _feedback_form__text_area0 = classes["feedback-form__text-area"]
export { _feedback_form__text_area0 as "feedback-form__text-area" }

const _feedback_form0 = classes["feedback-form"]
export { _feedback_form0 as "feedback-form" }

const _feedback_form__submit_button0 = classes["feedback-form__submit-button"]
export { _feedback_form__submit_button0 as "feedback-form__submit-button" }

const _feedback_form__form_header0 = classes["feedback-form__form-header"]
export { _feedback_form__form_header0 as "feedback-form__form-header" }

const _feedback_form__form_footer0 = classes["feedback-form__form-footer"]
export { _feedback_form__form_footer0 as "feedback-form__form-footer" }

const _feedback_form__vote_button_bar0 = classes["feedback-form__vote-button-bar"]
export { _feedback_form__vote_button_bar0 as "feedback-form__vote-button-bar" }

const _feedback_form__form0 = classes["feedback-form__form"]
export { _feedback_form__form0 as "feedback-form__form" }
